import React, { useEffect } from 'react';
import "./referandearn.css";
import NavBar from "../components/Nav";
import Footer from "../components/footer";
import ScrollTop from "../components/Scrolltop";
import Whatsapp from "../components/Whatsapp";
import Cosection from "../components/Cosections";
import { MdArrowForward, MdGroup, MdAttachMoney, MdSecurity } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Referandearn = () => {

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const navigate = useNavigate();

    
  return (
    <>
      <NavBar />

      <div className="refer-hero-section">
        <div className="hero-content">
          <h1>Refer & Earn</h1>
          <p>Share the Easy Tax Experts advantage and get rewarded for every successful referral</p>
           <button className="refer-hero-btn" onClick={() => navigate("/signup")}>
  Start Referring Now <MdArrowForward className="btn-icon" />
</button>

          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">$50K+</span>
              <span className="stat-label">Total Paid Out</span>
            </div>
            <div className="stat">
              <span className="stat-number">2,000+</span>
              <span className="stat-label">Successful Referrals</span>
            </div>
          </div>
        </div>
      </div>

      <div className="refer-container">
        {/* How It Works */}
        <div className="refer-card">
          <div className="card-header">
            <MdGroup className="card-icon" />
            <h2>How It Works</h2>
          </div>
          <div className="card-content">
            <p>
              Refer your friends, family, or colleagues to file taxes with
              <strong> Easy Tax Experts</strong> and earn rewards for every successful referral.
            </p>
            <p>
              Track your referral status in real-time from your dashboard.
              New user? <a href="/signup">Create your account</a> in just 60 seconds.
            </p>
          </div>
        </div>

        {/* Reward Structure */}
        <div className="bonus-section">
          <div className="section-header">
            
            <h2>Referral Reward Structure</h2>
            <p>Earn more as you refer more people</p>
          </div>

          <div className="bonus-grid">
            <div className="bonus-box">
              <div className="bonus-tier">Starter</div>
              <h3>1 - 10 Referrals</h3>
              <p className="amount">$10 / Referral</p>
              <p className="bonus-max">Up to $100</p>
            </div>
            <div className="bonus-box">
              <div className="bonus-tier">Growth</div>
              <h3>11 - 20 Referrals</h3>
              <p className="amount">$15 / Referral</p>
              <p className="bonus-max">Up to $150</p>
            </div>
            <div className="bonus-box">
              <div className="bonus-tier">Elite</div>
              <h3>21+ Referrals</h3>
              <p className="amount">$20 / Referral</p>
              <p className="bonus-max">Unlimited Earnings</p>
            </div>
          </div>
        </div>

        {/* Steps */}
<div className="steps-section">
  <h2>Simple 3-Step Process</h2>
  <div className="steps-grid">
    <div className="step">
      <div className="step-number">1</div>
      <h4>Sign Up & Create Account</h4>
      <p>Sign up and create your Easy Tax Experts account to get started.</p>
    </div>
    <div className="step">
      <div className="step-number">2</div>
      <h4>Enter Referral Details</h4>
      <p>Go to the referral page and enter details of your friends, family, or well-wishers who may benefit from our services.</p>
    </div>
    <div className="step">
      <div className="step-number">3</div>
      <h4>Earn Rewards</h4>
      <p>Get rewarded when your referrals successfully complete their tax filing with us.</p>
    </div>
  </div>
</div>




        {/* Policy */}
        <div className="policy-card">
          <div className="card-header">
            <MdSecurity className="card-icon" />
            <h2>Important Program Details</h2>
          </div>
          <div className="policy-content">
            <div className="policy-item">
              <h4>💰 Bonus Usage</h4>
              <p>Your referral bonus can be used to reduce your tax filing fees. Excess balance will be transferred to your bank account after <strong>April 25th</strong>.</p>
            </div>
            <div className="policy-item">
              <h4>⏰ Credit Timing</h4>
              <p>Bonus will be credited only after your referral completes the payment and files their taxes.</p>
            </div>
            <div className="policy-item">
              <h4>🔗 Valid Referrals</h4>
              <p>This program applies only to referrals submitted through the official referral system.</p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="final-cta">
          <h2>Ready to Start Earning?</h2>
          <p>Join thousands of satisfied clients who are already earning with our referral program</p>
          <button className="cta-button" onClick={() => window.location.href = "/signup"}>
            Get Started Today
          </button>
        </div>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </>
  );
};

export default Referandearn;